import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { ToastContainer } from "react-toastify";

import Landing from "./pages/Landing/Landing";
import QuotesPage from "./pages/QuotesPage/QuotesPage";
import ProposalPage from "./pages/Proposal/ProposalPage";
import ProposalSummary from "./pages/ProposalSummary/ProposalSummary";
import ThankYou from "./pages/ThankYou/ThankYou";
import LeadCapture from "./pages/LeadCapture/LeadCapture";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ShareButton from "./components/ShareButton/ShareButton";

import { theme } from "./styles/theme";

import "./App.scss";
import "./inlineStyles.scss";
import "react-toastify/dist/ReactToastify.css";

import useUrlQuery from "./hooks/useUrlQuery";
import { useEffect, useState } from "react";
import OtpModal from "./components/Modal/Otpmodal";


// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});



/* ---------------- APP CONTENT (INSIDE ROUTER) ---------------- */

function AppContent() {
  const [open, setOpen] = useState(false);
  const [sessionToken, setSessionToken] = useState("");

  const { getUrlQuery } = useUrlQuery();
  useEffect(() => {
    const token = getUrlQuery("session_token");
    const storedToken = sessionStorage.getItem("session_token");

    if (token && !storedToken) {
      sessionStorage.setItem("session_token", token);
      setSessionToken(token);
      setOpen(true);
    }
  }, []);

  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/proposal" element={<ProposalPage />} />
        <Route path="/summary" element={<ProposalSummary />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/qr/:id" element={<LeadCapture />} />
      </Routes>

      <Footer />
      <ShareButton />

      <OtpModal
        open={open}
        sessionToken={sessionToken}
        onSuccess={() => setOpen(false)}
        onClose={() => setOpen(false)}
      />
    </>
  );
}



/* ---------------- MAIN APP ---------------- */

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Router>
            <AppContent />
          </Router>

          <ReactQueryDevtools initialIsOpen={false} />

          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            limit={3}
            rtl={false}
            pauseOnHover
            theme="colored"
          />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;